import { FiCheckCircle, FiSearch, FiUserPlus } from 'react-icons/fi';
import { SiReaddotcv } from 'react-icons/si';
import { Bs1Square, Bs2Square, Bs3Square, Bs4Square } from 'react-icons/bs';

export const getWorkingProcessData = t => ({
  employeesLandingPage: {
    account: {
      icon: <FiUserPlus size={32} />,
      title: t('workingProcess.employees.account.title'),
      description: t('workingProcess.employees.account.description'),
    },
    resume: {
      icon: <SiReaddotcv size={32} />,
      title: t('workingProcess.employees.resume.title'),
      description: t('workingProcess.employees.resume.description'),
    },
    find: {
      icon: <FiSearch size={32} />,
      title: t('workingProcess.employees.findJob.title'),
      description: t('workingProcess.employees.findJob.description'),
    },
    add: {
      icon: <FiCheckCircle size={32} />,
      title: t('workingProcess.employees.addJob.title'),
      description: t('workingProcess.employees.addJob.description'),
    },
  },
  employersLandingPage: {
    account: {
      icon: <Bs1Square size={32} />,
      title: t('workingProcess.employers.account.title'),
      description: t('workingProcess.employers.account.description'),
    },
    resume: {
      icon: <Bs2Square size={32} />,
      title: t('workingProcess.employers.moderation.title'),
      description: t('workingProcess.employers.moderation.description'),
    },
    find: {
      icon: <Bs3Square size={32} />,
      title: t('workingProcess.employers.postVacancy.title'),
      description: t('workingProcess.employers.postVacancy.description'),
    },
    add: {
      icon: <Bs4Square size={32} />,
      title: t('workingProcess.employers.chooseSeekers.title'),
      description: t('workingProcess.employers.chooseSeekers.description'),
    },
  },
});
